import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">专题合集</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">七大板块 · 全方位覆盖娱乐八卦</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="flex items-start gap-3 p-4 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/30 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-1">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}